import { createRequest, handleErrorCatchLog } from 'Helpers/GenericHelpers'
import { getTokenFromSessionStorage } from 'Helpers/TokenHelper'

export interface IExpenseByChannelResponseDto {
  channel: string
  expenseType: string
  date: string
  amount: number
  summativeBehaviour: boolean
  customExpense: { id: number; name: string } | null
}

export async function getExpensesByChannel(
  store,
  year: number,
  month: number,
): Promise<IExpenseByChannelResponseDto[]> {
  const state = store.getState()
  const token = getTokenFromSessionStorage()
  if (!state.present.article.serverConfig || !token) {
    return []
  }

  const url = `/api/ExpensesByChannel?config=${state.present.article.serverConfig}`
  const queryString = `&year=${year}&month=${month}`

  try {
    const response = await createRequest(url + queryString, 'GET', undefined, token)
    const data = response.json()
    return data
  } catch (err) {
    handleErrorCatchLog(err, 'failed on retrieve expenses from getExpensesByChannel')
  }

  return []
}

export async function setExpensesByChannel(store, expensesByChannel: IExpenseByChannelResponseDto[]): Promise<void> {
  const state = store.getState()
  const token = getTokenFromSessionStorage()
  if (!state.present.article.serverConfig || !token) {
    return
  }

  const url = `/api/ExpensesByChannel?config=${state.present.article.serverConfig}`
  try {
    await createRequest(url, 'POST', { expensesByChannel }, token)
  } catch (err) {
    handleErrorCatchLog(err, 'failed calling setExpensesByChannel')
  }
}

export async function editExpensesByChannel(store, id: number, newName: string): Promise<void> {
  const state = store.getState()
  const token = getTokenFromSessionStorage()
  if (!state.present.article.serverConfig || !token) {
    return
  }

  const url = `/api/ExpensesByChannel/changeCustomExpense/${id}?config=${state.present.article.serverConfig}`
  try {
    await createRequest(url, 'POST', newName, token)
  } catch (err) {
    handleErrorCatchLog(err, 'failed calling deleteExpensesByChannel')
  }
}

export async function deleteExpensesByChannel(store, id: number): Promise<void> {
  const state = store.getState()
  const token = getTokenFromSessionStorage()
  if (!state.present.article.serverConfig || !token) {
    return
  }

  const url = `/api/ExpensesByChannel/changeCustomExpenses/${id}?config=${state.present.article.serverConfig}`
  try {
    await createRequest(url, 'POST', {}, token)
  } catch (err) {
    handleErrorCatchLog(err, 'failed calling deleteExpensesByChannel')
  }
}
